/* global $ */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line func-names
(function (angular) {
    'use strict';

    angular.module('app')
        .controller('quickCreateController', quickCreateController);

        quickCreateController.$inject = [
        '$interval',
        'HeartbeatApi',
        'heartbeat',
        'thisUser',
        'Polls',
        'Events',
        'Promotions',
        'Resources',
        'News',
        'Surveys',
    ];

    function quickCreateController(
        $interval,
        HeartbeatApi,
        heartbeat,
        thisUser,
        Polls,
        Events,
        Promotions,
        Resources,
        News,
        Surveys,
    ) {
        var vm = this;

        vm.heartbeat = heartbeat;

        vm.createEvent = createEvent;
        vm.createPoll = createPoll;
        vm.createSurvey = createSurvey;
        vm.createResource = createResource;
        vm.createPost = createPost;
        vm.createPromotion = createPromotion;

        /**
         * Shows the create poll modal
         * @return {void}
         */
         function createPoll(): void {
            Polls.managePoll();
        }

        /**
         * Shows the create poll modal
         * @return {void}
         */
        function createSurvey(): void {
          Surveys.manageSurvey();
        }

        /**
         * Shows the create event modal
         * @return {void}
         */
        function createEvent(): void {
            Events.create();
        }

        /**
         * Shows the create promotion modal
         * @return {void}
         */
        function createPromotion(): void {
            Promotions.managePromotion();
        }

        /**
         * Shows the create resource modal
         * @return {void}
         */
        function createResource(): void {
            Resources.manageResource();
        }

        /**
         * Shows the create post modal
         * @return {void}
         */
        function createPost(): void {
            News.manageNews();
        }

        if (!thisUser) {
            return;
        }
    }

}(angular));
